module.exports = __webpack_public_path__ + "img/image.7d3b9c98.png";